<script setup lang="ts">
import {ConversationMessage} from "@/conversation/interfaces";
import {Tooltip, TooltipContent, TooltipProvider, TooltipTrigger} from "@/core/components/ui/tooltip";
import {Eye} from "@lucide/vue";
import ConversationMessagePreview from "@/conversation/components/ConversationMessagePreview.vue";

defineProps<{
    message: ConversationMessage
}>();
</script>

<template>
  <TooltipProvider :delay-duration="200">
    <Tooltip>
      <TooltipTrigger as-child class="cursor-pointer" @click.stop>
        <Eye class="text-primary size-6" />
      </TooltipTrigger>
      <TooltipContent class="bg-white max-w-sm shadow-2xl" avoid-collisions>
        <ConversationMessagePreview :message="message" />
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
</template>
